import { ApplicationElement, html } from '@effectivastudio/lit-components';
import ChatListItem from '@effectivastudio/lit-components/components/chat_list_item/element.js';
import style from './style.lit.css';
import '@effectivastudio/lit-components/components/badge/element.js';

/**
 * @cssprop --avatar-size - For avatar size
 * @cssprop --background-color - Component background color
 * @cssprop --color - User name color
 * @cssprop --color-secondary - Message text color.
 * @cssprop --dot-menu-trigger-width - Dot menu width
 * @cssprop --dot-menu-trigger-radius - Dot menu radius
 * @cssprop --dot-menu-trigger-border - Dot menu border
 * @cssprop --dot-menu-trigger-bg - Dot menu background color
 * @cssprop --dot-menu-trigger-bg-hover - Dot menu hover color
 * @cssprop --dot-menu-trigger-bg-active - Dot menu active color
 */

export default class ChatListItemExtended extends ChatListItem {
  static styles = [ApplicationElement.styles, style];

  renderLabel() {
    return html`<ef-badge count=${this.count} theme="danger"></ef-badge>`;
  }
}

customElements.get('xs-chat-list-item') ||
  customElements.define('xs-chat-list-item', ChatListItemExtended);
